<style>
.body{
    background: #ececed;
    color: #a1aed4;
    font-size: 14px;
    margin: 0;
    overflow-anchor: none;
    font-family: Roboto Condensed, sans-serif;
    overflow-x: hidden;
    scroll-behavior: smooth;
}
.odd-btn{
    height: 44px;
    border-radius: 4px;
}
.mbtn{
      height: 44px;
    border-radius: 4px;
}
</style>
<style>
                .newhead{
                        background-color: #072c50;

                }
            </style>
<div class="box mt-1">
  <div class="ballbyshow">
    <h4 class="text-light d-flex align-items-center mb-0">
      <!-- <i class="fas fa-info-circle"></i>
      <div class="ballby ml-1">Ball By Ball</div> -->
    </h4>
  </div>
  <iframe
    *ngIf="inplay"
    style="width: 100%; height: 100%"
    frameborder="0"
    allowfullscreen
    [src]="scoreurl"
  ></iframe>
  <div class="iframe-container" *ngIf="show_tv">
    <iframe frameborder="0" allowfullscreen [src]="videourl"></iframe>
  </div>
  <!-- <iframe
    width="100%"
    style="min-height: 220px !important"
    [src]="videourl"
  ></iframe> -->
  <div class="bg-title d-flex justify-content-between">
    <div
      class="title d-flex justify-content-between align-items-center p-2 match-name"
      *ngIf="markets.length > 0"
    >
      <!-- <img src="assets/images/blue_cric.png" /> -->
      <div class="ml-0">
        <div class="h5 mb-0 text-left" style="font-size: 10px">
          {{ competition_name + " > " + market_name }}
          <!-- {{ market[0].runner1 }} vs {{ market[0].runner2 }} -->
        </div>
        <div style="font-size: 10px">
          {{ market[0].start_time | date : "dd/MM/YYYY H:mm" : "UTC" }}
          (UTC+05:30)
        </div>
      </div>
      <div (click)="toggleShowTv()">
        <i class="fas fa-tv"></i>
      </div>
    </div>
  </div>

  <!-- <div class="">
    {{ inplay }}
    <iframe
      *ngIf="inplay"
      style="border: none"
      width="100%"
      [src]="scorecard"
      frameborder="0"
      #scoreboardIframe
    ></iframe>
  </div> -->

  <mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    dynamicHeight
    mat-stretch-tabs="false"
    mat-align-tabs="start"
  >
    <mat-tab label="ALL">
      <div *ngIf="markets.length < 1" class="nodata">
        <span>No Data Found...</span>
      </div>
      <div class="card rounded" *ngIf="market.length > 0">
        <div style="" class="text-light">
          <span class="newhead">
            <span style="margin-left: -10px">
              <img
                src="https://wver.sprintstaticdata.com/v79/static/front/img/arrow-down.svg"
                class="mr-1"
              />
              <span style="position: absolute; margin-left: 7px"
                >MATCH ODDS</span
              >
            </span>
            <span
              class="text-light float-right"
              style="font-size: 12px; font-weight: 600px"
              >Max: 1L</span
            >
          </span>
        </div>
        <div class="card-body p-0">
          <div class="d-flex justify-content-between d-none-mobile mt-1 bl-btn">
            <div class="title text-right">&nbsp;</div>
            <button class="btn mbtn p-0 font-weight-bold odd-btn">
              &nbsp;
            </button>
            <button class="btn mbtn p-0 ml-1 font-weight-bold odd-btn">
              &nbsp;
            </button>
            <button
              class="btn mbtn p-0 font-weight-bold odd-btn text-light max-details"
            >
              Max: 2L
            </button>
            <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn">
              Back
            </button>

            <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn">
              Lay
            </button>
            <button class="btn mbtn p-0 ml-1 font-weight-bold odd-btn">
              &nbsp;
            </button>
          </div>
          <div class="d-flex p-1">
            <div class="title">
              <span class="font-12">{{ market[0].runner1 }}</span
              ><br />
              <!--              {{market.exp_amount1}}-->
              <span
                class="font-weight-bold"
                *ngIf="market[0].exp_amount1 != 0"
                [class.text-danger]="market[0].exp_amount1 < 0"
                [class.text-success]="market[0].exp_amount1 >= 0"
                >{{ market[0].exp_amount1 }}</span
              >
            </div>
            <button
              #btn
              mat-button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back02_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back02_price,
                  market[0].back02_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back02_price }}</b
              ><br /><small>{{
                market[0].back02_size | numberFormatter
              }}</small>
            </button>
            <button
              #btn
              mat-button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back01_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back01_price,
                  market[0].back01_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back01_price }}</b
              ><br /><small>{{
                market[0].back01_size | numberFormatter
              }}</small>
            </button>
            <button
              #btn
              mat-button
              *ngIf="market[0].status == 'OPEN'; else suspendMarket"
              [disabled]="market[0].back0_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back0_price,
                  market[0].back0_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back0_price }}</b
              ><br /><small>{{ market[0].back0_size | numberFormatter }}</small>
            </button>
            <ng-template #suspendMarket>
              <div
                title="SUSPENDED"
                class="suspendedtext d-flex justify-content-between"
              >
                <!-- <button class="btn mbtn bg-blue p-0 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold book-btn2"  >
                  0 <br /><small>0</small>
                </button> -->
                <button class="btn mbtn bg-blue p-0 ml-1 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
                <button class="btn mbtn bg-pink p-0 ml-1 font-weight-bold">
                  0 <br /><small>0</small>
                </button>
              </div>
            </ng-template>
            <br />
            <button
              *ngIf="market[0].status == 'OPEN'"
              [disabled]="market[0].lay0_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay0_price,
                  market[0].lay0_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay0_price }}</b> <br /><small>{{
                market[0].lay0_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay01_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay01_price,
                  market[0].lay01_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay01_price }}</b> <br /><small>{{
                market[0].lay01_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay02_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay02_price,
                  market[0].lay02_size,
                  market[0].runner1,
                  1,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay02_price }}</b> <br /><small>{{
                market[0].lay02_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
          <div class="d-flex p-1">
            <div class="title">
              <span class="font-12">{{ market[0].runner2 }}</span
              ><br />
              <span
                *ngIf="market[0].exp_amount2 != 0"
                class="font-weight-bold"
                [class.text-danger]="market[0].exp_amount2 < 0"
                [class.text-success]="market[0].exp_amount2 >= 0"
                >{{ market[0].exp_amount2 }}</span
              >
            </div>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back12_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back12_price,
                  market[0].back12_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back12_price }}</b> <br /><small>{{
                market[0].back12_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back11_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back11_price,
                  market[0].back11_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back11_price }}</b> <br /><small>{{
                market[0].back11_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN'; else suspendMarket"
              [disabled]="market[0].back1_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back1_price,
                  market[0].back1_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back1_price }}</b> <br /><small>{{
                market[0].back1_size | numberFormatter
              }}</small>
            </button>
            <br />
            <button
              *ngIf="market[0].status == 'OPEN'"
              [disabled]="market[0].lay1_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay1_price,
                  market[0].lay1_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay1_price }}</b> <br /><small>{{
                market[0].lay1_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay11_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay11_price,
                  market[0].lay11_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay11_price }}</b> <br /><small>{{
                market[0].lay11_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay12_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay12_price,
                  market[0].lay12_size,
                  market[0].runner2,
                  2,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay12_price }}</b> <br /><small>{{
                market[0].lay12_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
          <div *ngIf="market[0].back2_price != null" class="d-flex p-1">
            <div class="title">
              <span class="font-12">Draw</span><br />
              <span
                class="font-weight-bold"
                [class.text-danger]="market[0].exp_amount3 < 0"
                [class.text-success]="market[0].exp_amount3 >= 0"
                >{{ market[0].exp_amount3 }}</span
              >
            </div>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back22_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back22_price,
                  market[0].back22_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back22_price }}</b> <br /><small>{{
                market[0].back22_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].back21_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back21_price,
                  market[0].back21_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back21_price }}</b> <br /><small>{{
                market[0].back21_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN'; else suspendMarket"
              [disabled]="market[0].back2_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Back',
                  market[0].back2_price,
                  market[0].back2_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-blue p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].back2_price }}</b> <br /><small>{{
                market[0].back2_size | numberFormatter
              }}</small>
            </button>
            <br />
            <button
              *ngIf="market[0].status == 'OPEN'"
              [disabled]="market[0].lay2_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay2_price,
                  market[0].lay2_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay2_price }}</b> <br /><small>{{
                market[0].lay2_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay21_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay21_price,
                  market[0].lay21_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay21_price }}</b> <br /><small>{{
                market[0].lay21_size | numberFormatter
              }}</small>
            </button>
            <button
              *ngIf="market[0].status == 'OPEN' && 3 > 6"
              [disabled]="market[0].lay22_price == 0"
              (click)="
                openDialog(
                  'match_odd',
                  'Lay',
                  market[0].lay22_price,
                  market[0].lay22_size,
                  market[0].runner3,
                  3,
                  100,
                  100000
                )
              "
              class="btn mbtn bg-pink p-0 ml-1 font-weight-bold odd-btn"
            >
              <b>{{ market[0].lay22_price }}</b> <br /><small>{{
                market[0].lay22_size | numberFormatter
              }}</small>
            </button>
            <br />
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="3 > 6" label="BETs">
      <!--            tennis bets-->
      <div
        class="card mt-3 border border-warning rounded"
        *ngIf="tennis_bets.length > 0"
      >
        <div style="" class="text-light">
          <div class="title text-light">
            <span class="newhead">Tennis Bets</span><br />
          </div>
        </div>
        <div class="card-body p-0">
          <div
            (click)="selectTab(0)"
            *ngFor="let tennisbet of tennis_bets"
            class="d-flex justify-content-between p-2 border-secondary border-bottom"
          >
            <div class="title">
              <span>{{ tennisbet.runner_name + "  " }}</span
              ><span
                style="font-size: 13px"
                class="badge"
                [class.badge-danger]="tennisbet.is_won == 0"
                [class.badge-success]="tennisbet.is_won == 1"
                *ngIf="tennisbet.status == 0"
                >{{ tennisbet.is_won == 1 ? "Won" : "Lose" }}</span
              ><br />
              <span
                class="badge"
                style="font-size: 12px"
                [class.badge-info]="tennisbet.type == 'Back'"
                [class.badge-danger]="tennisbet.type == 'Lay'"
                >{{ tennisbet.type }}</span
              ><span class="badge badge-warning ml-2">{{
                tennisbet.status == 1 ? "OPEN" : "CLOSED"
              }}</span
              ><br />
              <span>{{ tennisbet.updated_at | date : "short" }}</span>
            </div>
            <div class="title" class="float-right w-50 text-right">
              <span class="text-white">Odds: Match Odds</span><br />
              <span class="text-white"
                >Stack:{{
                  tennisbet.type == "Back"
                    ? math.abs(tennisbet.loss_amount)
                    : tennisbet.win_amount
                }}</span
              >
              <br />
              <span class="text-white">P&L: {{ tennisbet.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
